import { translate as $t } from '@/assets/languages'
import store from '@/store'
import axios from 'axios'
import Vue from 'vue'

import routerBabe from '../router/babe.js'
import routerUser from '../router/user.js'
import { getToken } from './auth'
import { showFullScreenLoading, tryHideFullScreenLoading } from './loading'
import { tansParams } from './qmis'

// axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const baseURL =
  process.env.NODE_ENV === 'production'
    ? '//api-babe.krazefootball.com/' // api-babe.cc0094.com
    : '//test-api-babe.cc0094.com/'

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: baseURL, // process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 50000
})
// request拦截器
service.interceptors.request.use(
  (config) => {
    // 是否需要设置 token
    console.log(config)
    const isToken = (config.headers || {}).isToken === false
    console.log(process.env)
    config.headers['timezone'] =
      Intl.DateTimeFormat().resolvedOptions().timeZone
    config.headers['offset'] = new Date().getTimezoneOffset()
    if (store.state.role === 'user') {
      config.headers['language'] = localStorage.getItem('lang')
        ? localStorage.getItem('lang')
        : 'en'
    } else if (store.state.role === 'babe') {
      config.headers['babe-language'] = localStorage.getItem('lang')
        ? localStorage.getItem('lang')
        : 'en'
    } else if (store.state.role === 'mcn') {
      config.headers['mcn-language'] = localStorage.getItem('lang')
        ? localStorage.getItem('lang')
        : 'en'
    }
    if (getToken() && !isToken) {
      if (store.state.role === 'user') {
        config.headers['user-token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
        config.headers['user-id'] = localStorage.getItem('user_id')
      } else if (store.state.role === 'babe') {
        config.headers['babe-token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
        config.headers['babe-user-id'] = localStorage.getItem('user_id')
      } else if (store.state.role === 'mcn') {
        config.headers['mcn-token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
        config.headers['mcn-user-id'] = localStorage.getItem('user_id')
      }
      // config.headers['USER_ORG_CODE'] = store.state.user.deptCodePathAll
    }
    // get请求映射params参数
    // if (config.method === 'get' && config.params) {
    //   let url = config.url + '?'
    //   for (const propName of Object.keys(config.params)) {
    //     const value = config.params[propName]
    //     var part = encodeURIComponent(propName) + '='
    //     if (value !== null && typeof value !== 'undefined') {
    //       if (typeof value === 'object') {
    //         for (const key of Object.keys(value)) {
    //           let params = propName + '[' + key + ']'
    //           var subPart = encodeURIComponent(params) + '='
    //           url += subPart + encodeURIComponent(value[key]) + '&'
    //         }
    //       } else {
    //         url += part + encodeURIComponent(value) + '&'
    //       }
    //     }
    //   }
    //   url = url.slice(0, -1)
    //   config.params = {}
    //   config.url = url
    // }
    if (config.method === 'post' || config.method === 'put') {
      showFullScreenLoading()
    }
    return config
  },
  (error) => {
    console.log(error)
    tryHideFullScreenLoading()
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // 未设置状态码则默认成功状态
    if (res.config.method === 'post' || res.config.method === 'put') {
      tryHideFullScreenLoading()
    }
    const code = res.data.errorCode // 0为成功，900-1000表示登录状态失效，其余为错弹出框报错
    // 获取错误信息
    const msg = res.data.errorMsg
    if (code === 0) {
      return res.data
    } else {
      if (code <= 1000 && code >= 900) {
        Vue.$messagebox
          .confirm(
            msg,
            { confirmButtonText: $t('ok'), cancelButtonText: $t('cancel') },
            ''
          )
          .then(() => {
            store.dispatch('LogOut').then(() => {
              console.log(Vue.prototype)
              Vue.prototype.$bus.emit('handleLogin')
            })
          })
          .catch(() => {})
      } else {
        Vue.$messagebox
          .alert(msg, { confirmButtonText: $t('ok') }, '')
          .then(() => {
            if (code === 20005) {
              routerBabe.push({ path: '/' })
            } else if (code === 10018) {
              if (store.state.role === 'user') {
                routerUser.push({ path: '/user/actcategory' })
              } else {
                routerBabe.push({ path: '/babe/activity' })
              }
            }
          })
      }
      return Promise.reject(msg)
    }
  },
  (error) => {
    console.log('7777777')
    console.log(error)
    tryHideFullScreenLoading()
    console.log('err' + error)
    let { message } = error
    if (message === 'Network Error') {
      message = 'Network anomalies'
    } else if (message.includes('timeout')) {
      message = 'The request timeout'
    } else if (message.includes('Request failed with status code')) {
      message = 'Abnormal interface' + message.substr(message.length - 3)
    }
    Vue.$messagebox.alert(message, { confirmButtonText: $t('ok') }, '')
    tryHideFullScreenLoading()
    return Promise.reject(error)
  }
)

// 通用下载方法
export function download(url, params, filename) {
  return service
    .post(url, params, {
      transformRequest: [
        (params) => {
          return tansParams(params)
        }
      ],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      responseType: 'blob'
    })
    .then((data) => {
      const content = data
      const blob = new Blob([content])
      if ('download' in document.createElement('a')) {
        const elink = document.createElement('a')
        elink.download = filename
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else {
        navigator.msSaveBlob(blob, filename)
      }
    })
    .catch((r) => {
      console.error(r)
    })
}

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js